// MCP connector OAuth models (RYDE-7833) — mirror the backend consent/grants DTOs.

export interface IOauthConsentEligibleCompanyDto {
  companyId: number;
  companyName: string;
  /** Strict tenant: approving for this company requires fresh credential entry. */
  forceLogin: boolean;
}

export interface IOauthConsentRequestDto {
  requestId: string;
  clientName: string;
  clientUri?: string | null;
  logoUri?: string | null;
  /** Space-delimited requested scope ("mcp:read mcp:write"). */
  scope: string;
  /** True when the OAuth client demanded a fresh login (prompt=login). */
  promptLogin: boolean;
  eligibleCompanies: IOauthConsentEligibleCompanyDto[];
  /** Epoch ms the request was created. */
  createdAt: number;
}

export interface IOauthConsentRedirectDto {
  /** Absolute client redirect URL (code+state on approve, error=access_denied on deny). */
  redirectTo: string;
}

export interface IOauthGrantListItemDto {
  grantId: string;
  clientName: string;
  clientUri?: string | null;
  logoUri?: string | null;
  scope: string;
  companyId: number;
  /** Serialized from the grant's timestamp columns, so an ISO instant — never a display string. */
  createdAt: TDateISO;
  lastUsedAt?: TDateISO | null;
}

export interface IOauthRevokeAllResultDto {
  revokedCount: number;
}

/** RFC 9728 protected-resource metadata: only the fields the dashboard reads, named as the RFC names them. */
export interface IOauthProtectedResourceMetadataDto {
  resource: string;
  /** Public "connect your AI" page on the MCP server; absent when the deployment has no MCP host. */
  resource_documentation?: string;
}

export const OAUTH_SCOPE_READ = "mcp:read";
export const OAUTH_SCOPE_WRITE = "mcp:write";
